// Point de rupture « téléphone » (< 600 px) : celui où v-data-table empile ses lignes.
export default {
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    }
  }
}
